import React from 'react';
import { Link } from 'react-router-dom';

// Öffentliche PDF-Download-Seite — kein Login nötig (User-Wunsch 08/2026).
// 3 Sprachen × 3 Varianten = 9 PDFs (Vollversion + Produkt + Vergütungsplan).

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SECTIONS = [
  {
    lang: 'de',
    heading: 'Deutsch',
    kicker: 'PRÄSENTATION · PDF · DE',
    variants: [
      { key: 'full',    label: 'Komplette Präsentation', sub: 'Alle 33 Folien · schwarzer Hintergrund' },
      { key: 'product', label: 'Produktpräsentation',    sub: 'Hero → „Der einfache Weg" · 25 Folien' },
      { key: 'plan',    label: 'Vergütungsplan',         sub: '„Der einfachste und fairste Weg" → Instagram · 9 Folien' },
    ],
  },
  {
    lang: 'en',
    heading: 'English',
    kicker: 'PRESENTATION · PDF · EN',
    variants: [
      { key: 'full',    label: 'Complete presentation', sub: 'All 33 slides · black background' },
      { key: 'product', label: 'Product presentation',  sub: 'Hero → "The simple way" · 25 slides' },
      { key: 'plan',    label: 'Compensation plan',     sub: '"The simplest and fairest way" → Instagram · 9 slides' },
    ],
  },
  {
    lang: 'tr',
    heading: 'Türkçe',
    kicker: 'SUNUM · PDF · TR',
    variants: [
      { key: 'full',    label: 'Tam sunum',        sub: 'Tüm 33 slayt · siyah arka plan' },
      { key: 'product', label: 'Ürün sunumu',      sub: 'Hero → „Basit yol" · 25 slayt' },
      { key: 'plan',    label: 'Ödeme planı',      sub: '„En basit ve adil yol" → Instagram · 9 slayt' },
    ],
  },
];

const filenameFor = (lang, variant) => {
  if (variant === 'full')    return `stig-rock-presentation-${lang}.pdf`;
  if (variant === 'product') return `stig-rock-produkt-${lang}.pdf`;
  return `stig-rock-plan-${lang}.pdf`;
};

export default function PdfPage() {
  return (
    <div className="pdf-public-page" data-testid="pdf-public-page">
      <div className="pdf-public-wrap">
        <div className="pdf-public-brand">
          <img
            src="/brand/stig-rock-logo-white.png"
            alt="STIG ROCK"
            className="pdf-public-logo"
            draggable={false}
          />
        </div>

        <h1 className="pdf-public-title font-display" data-testid="pdf-public-title">
          Präsentation als PDF
        </h1>
        <p className="pdf-public-sub font-ui">
          Lade die aktuelle STIG&nbsp;ROCK Präsentation als PDF-Datei herunter — vollständig,
          nur Produktteil oder nur Vergütungsplan. Für den interaktiven Zugang bitte einloggen.
        </p>

        {SECTIONS.map((section) => (
          <div
            key={section.lang}
            className="pdf-public-lang-block"
            data-testid={`pdf-public-block-${section.lang}`}
          >
            <div className="pdf-public-lang-heading" data-testid={`pdf-public-lang-heading-${section.lang}`}>
              {section.heading}
            </div>
            <div className="pdf-public-links">
              {section.variants.map((v) => (
                <a
                  key={v.key}
                  href={`${API}/pdf/download/${section.lang}/${v.key}`}
                  download={filenameFor(section.lang, v.key)}
                  className="pdf-public-link"
                  data-testid={`pdf-public-download-${section.lang}-${v.key}`}
                >
                  <span className="pdf-public-link-kicker">
                    {section.kicker} · {v.key.toUpperCase()}
                  </span>
                  <span className="pdf-public-link-title">{v.label}</span>
                  <span className="pdf-public-link-sub">{v.sub}</span>
                </a>
              ))}
            </div>
          </div>
        ))}

        {/* Offline-Bundle (Mac + Windows, autark, 649 MB) — Event-Notfall */}
        <div className="pdf-public-lang-block" data-testid="pdf-public-block-offline">
          <div className="pdf-public-lang-heading">Offline-Präsentation (English)</div>
          <div className="pdf-public-links">
            <a
              href="/stig-rock-offline-en.zip"
              download="stig-rock-offline-en.zip"
              className="pdf-public-link"
              data-testid="pdf-public-download-offline-en"
            >
              <span className="pdf-public-link-kicker">OFFLINE BUNDLE · ZIP · EN</span>
              <span className="pdf-public-link-title">Complete offline presentation</span>
              <span className="pdf-public-link-sub">
                Mac + Windows · Doppelklick auf PRAESENTATION-STARTEN.html · kein Terminal, keine Installation
              </span>
            </a>
          </div>
        </div>

        <div className="pdf-public-footer">
          <Link to="/login" data-testid="pdf-public-login-link" className="pdf-public-login">
            Zum Login →
          </Link>
        </div>
      </div>
    </div>
  );
}
